import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const SubmitInputI18n = {
  configuration: { namespace: I18nNamespace.SUBMIT_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.submit,
  },
};
